import * as action from './actions';
import * as actionTypes from './actionTypes';
import { loadPersistedPlan, persistPlan } from './persistence';
import { PlanMealType } from './types';

import { InferValueTypes } from '@/types/commonTypes';

type ActionType = ReturnType<InferValueTypes<typeof action>>;

type MealType = {
    id: number;
    name: string;
    cover: string;
    cookingLevel: string;
    cookingTime: number;
    nutrients: {
        kilocalories: number;
        fat: number;
        carbs: number;
        protein: number;
    };
    steps: {
        position: number;
        text: string;
    }[];
    ingredients: {
        id: number;
        name: string;
        measure: string;
        quantity: number | string;
    }[];
    mealType: string;
};
interface NutritionState {
    meal: MealType | null;
    plan: PlanMealType[];
    isLoading: boolean;
}

const initialState: NutritionState = {
    meal: null,
    plan: loadPersistedPlan(),
    isLoading: true,
};

const nutritionReducer = (state: NutritionState = initialState, action: ActionType): NutritionState => {
    switch (action.type) {
        case actionTypes.SET_LOADING_STATE:
            return { ...state, isLoading: true };

        case actionTypes.SET_MEAL:
            return {
                ...state,
                meal: {
                    mealType: state.plan.find((meal) => meal.id === action.payload.id)?.mealType || '',
                    id: action.payload.id,
                    name: action.payload.name,
                    cover: action.payload.cover,
                    cookingLevel: action.payload.cooking_level,
                    cookingTime: action.payload.cooking_time / 60,
                    nutrients: {
                        kilocalories: parseInt(action.payload.nutrients.kilocalories.toFixed()),
                        fat: parseInt(action.payload.nutrients.fat.toFixed()),
                        carbs: parseInt(action.payload.nutrients.carbs.toFixed()),
                        protein: parseInt(action.payload.nutrients.protein.toFixed()),
                    },
                    steps: action.payload.steps.map((step: { position: number; text: string }) => ({
                        position: step.position + 1,
                        text: step.text,
                    })),
                    ingredients: action.payload.ingredients.map(
                        (ingredient: { id: number; name: string; measure_name: string; quantity: number }) => ({
                            id: ingredient.id,
                            name: ingredient.name,
                            measure: ingredient.measure_name,
                            quantity:
                                parseInt(ingredient.quantity.toFixed()) === 0
                                    ? ''
                                    : parseInt(ingredient.quantity.toFixed()),
                        })
                    ),
                },
                isLoading: false,
            };

        case actionTypes.SET_MEAL_PLAN: {
            const plan = action.payload.flatMap(
                ({ meal_type, meals }) =>
                    meals.map((meal) => ({
                        id: meal.id,
                        name: meal.name,
                        cover: meal.cover,
                        cookingLevel: meal.cooking_level,
                        cookingTime: meal.cooking_time / 60,
                        kilocalories: parseInt(meal.nutrients.kilocalories.toFixed()),
                        mealType: meal_type,
                    }))[0]
            );

            persistPlan(plan);

            return { ...state, plan, isLoading: false };
        }

        default:
            return state;
    }
};

export default nutritionReducer;
